// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2KODM","insightsList":"newBusinessInsightsMenu_insightsList__3-SRn","active":"newBusinessInsightsMenu_active__15p1V"};